export const replaceLocation = (url: string): void => {
  window.location.replace(url)
}
